import { type ReactNode, type SVGProps } from 'react';

export interface LoyaltyIconProps extends SVGProps<SVGSVGElement> {
    size?: 'small' | 'medium';
}

export type LoyaltyIconComponent = (props: LoyaltyIconProps) => JSX.Element;

interface LoyaltySvgIconProps extends LoyaltyIconProps {
    children: ReactNode;
}

/** Shared 24×24 `currentColor` canvas for loyalty icons (progress cells + balance badge). */
export const LoyaltySvgIcon = ({
    size = 'medium',
    children,
    ...props
}: LoyaltySvgIconProps): JSX.Element => {
    const dimension = size === 'small' ? 20 : 24;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            width={dimension}
            height={dimension}
            {...props}
        >
            {children}
        </svg>
    );
};
